import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useRef, useState, useEffect } from 'react';
import { u as useLocalization } from './LocalizationContext-a82461b5.js';
import { useVoicePlayer } from './VoicePlayer/useVoicePlayer.js';
import { useVoiceRecorder, VoiceRecorderStatus } from './VoiceRecorder/useVoiceRecorder.js';
import { a as isDisabledBecauseFrozen, b as isDisabledBecauseMuted } from './ChannelProvider-5dcbee7b.js';
import { V as VoiceMessageInputStatus, a as VoiceMessageInput } from './index-090cbf21.js';
import Modal from './ui/Modal.js';
import Button, { ButtonTypes, ButtonSizes } from './ui/Button.js';
import useSendbirdStateContext from './useSendbirdStateContext.js';
import { a as VOICE_RECORDER_DEFAULT_MIN } from './consts-fa6ab3c0.js';
import { a as VOICE_PLAYER_STATUS } from './index-fa5b2b8c.js';
import { u as uuidv4 } from './uuid-717930b4.js';
var VoiceMessageInputWrapper = function VoiceMessageInputWrapper(_ref) {
  var _config$voiceRecord;
  var channel = _ref.channel,
    _onCancelClick = _ref.onCancelClick,
    onSubmitClick = _ref.onSubmitClick;
  var uuid = useRef(uuidv4()).current;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    audioFile = _useState2[0],
    setAudioFile = _useState2[1];
  var _useState3 = useState(VoiceMessageInputStatus.READY_TO_RECORD),
    _useState4 = _slicedToArray(_useState3, 2),
    voiceInputState = _useState4[0],
    setVoiceInputState = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSubmitted = _useState6[0],
    setSubmit = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDisabled = _useState8[0],
    setDisabled = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showModal = _useState0[0],
    setShowModal = _useState0[1];
  var _useLocalization = useLocalization(),
    stringSet = _useLocalization.stringSet;
  var _useSendbirdStateCont = useSendbirdStateContext(),
    config = _useSendbirdStateCont.config;
  var minRecordingTime = (config === null || config === void 0 ? void 0 : (_config$voiceRecord = config.voiceRecord) === null || _config$voiceRecord === void 0 ? void 0 : _config$voiceRecord.minRecordingTime) || VOICE_RECORDER_DEFAULT_MIN;
  var _useVoiceRecorder = useVoiceRecorder({
      onRecordingStarted: function onRecordingStarted() {
        setVoiceInputState(VoiceMessageInputStatus.RECORDING);
      },
      onRecordingEnded: function onRecordingEnded(audioFile) {
        setAudioFile(audioFile);
      }
    }),
    start = _useVoiceRecorder.start,
    stop = _useVoiceRecorder.stop,
    cancel = _useVoiceRecorder.cancel,
    recordingTime = _useVoiceRecorder.recordingTime,
    recordingStatus = _useVoiceRecorder.recordingStatus,
    recordingLimit = _useVoiceRecorder.recordingLimit;
  var voicePlayer = useVoicePlayer({
    channelUrl: channel === null || channel === void 0 ? void 0 : channel.url,
    key: uuid,
    audioFile: audioFile
  });
  var play = voicePlayer.play,
    pause = voicePlayer.pause,
    playbackTime = voicePlayer.playbackTime,
    playingStatus = voicePlayer.playingStatus;
  var stopVoicePlayer = voicePlayer.stop;

  // disabled state: muted & frozen
  useEffect(function () {
    if (isDisabledBecauseFrozen(channel) || isDisabledBecauseMuted(channel)) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [channel === null || channel === void 0 ? void 0 : channel.myRole, channel === null || channel === void 0 ? void 0 : channel.isFrozen, channel === null || channel === void 0 ? void 0 : channel.myMutedState]);

  // call onSubmitClick when submit button is clicked and recorded audio file is created
  useEffect(function () {
    if (isSubmitted && audioFile) {
      onSubmitClick(audioFile, recordingTime);
      setSubmit(false);
      setAudioFile(null);
    }
  }, [isSubmitted, audioFile, recordingTime]);
  // operate which control button should be displayed
  useEffect(function () {
    if (audioFile) {
      if (recordingTime < minRecordingTime) {
        setVoiceInputState(VoiceMessageInputStatus.READY_TO_RECORD);
        setAudioFile(null);
      } else if (playingStatus === VOICE_PLAYER_STATUS.PLAYING) {
        setVoiceInputState(VoiceMessageInputStatus.PLAYING);
      } else {
        setVoiceInputState(VoiceMessageInputStatus.READY_TO_PLAY);
      }
    }
  }, [audioFile, recordingTime, playingStatus]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-input-wrapper"
  }, /*#__PURE__*/React__default.createElement(VoiceMessageInput, {
    currentValue: recordingStatus === VoiceRecorderStatus.COMPLETED ? playbackTime : recordingTime,
    maximumValue: recordingStatus === VoiceRecorderStatus.COMPLETED ? recordingTime : recordingLimit,
    currentType: voiceInputState,
    onCancelClick: function onCancelClick() {
      _onCancelClick();
      cancel();
      stopVoicePlayer();
    },
    onSubmitClick: function onSubmitClick() {
      if (isDisabled) {
        setShowModal(true);
        setVoiceInputState(VoiceMessageInputStatus.READY_TO_RECORD);
      } else {
        stop();
        pause();
        setSubmit(true);
      }
    },
    onControlClick: function onControlClick(type) {
      switch (type) {
        case VoiceMessageInputStatus.READY_TO_RECORD:
          {
            stopVoicePlayer();
            start();
            break;
          }
        case VoiceMessageInputStatus.RECORDING:
          {
            if (recordingTime >= minRecordingTime && !isDisabled) {
              stop();
            } else if (isDisabled) {
              cancel();
              setShowModal(true);
              setVoiceInputState(VoiceMessageInputStatus.READY_TO_RECORD);
            } else {
              cancel();
              setVoiceInputState(VoiceMessageInputStatus.READY_TO_RECORD);
            }
            break;
          }
        case VoiceMessageInputStatus.READY_TO_PLAY:
          {
            play();
            break;
          }
        case VoiceMessageInputStatus.PLAYING:
          {
            pause();
            break;
          }
      }
    }
  }), showModal && /*#__PURE__*/React__default.createElement(Modal, {
    className: "sendbird-voice-message-input-wrapper-alert",
    titleText: isDisabledBecauseMuted(channel) ? stringSet.MODAL__VOICE_MESSAGE_INPUT_DISABLED__TITLE_MUTED : stringSet.MODAL__VOICE_MESSAGE_INPUT_DISABLED__TITLE_FROZEN,
    hideFooter: true,
    isCloseOnClickOutside: true,
    onCancel: function onCancel() {
      setShowModal(false);
      _onCancelClick();
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-input-wrapper-alert__body"
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: "sendbird-voice-message-input-wrapper-alert__body__ok-button",
    type: ButtonTypes.PRIMARY,
    size: ButtonSizes.BIG,
    onClick: function onClick() {
      setShowModal(false);
      _onCancelClick();
    }
  }, stringSet.BUTTON__OK))));
};
export { VoiceMessageInputWrapper as V };